import { Controller } from "@hotwired/stimulus"
import { debugLog } from "../utils";
import { rrFetch } from "../utils/rr_fetch"

export default class extends Controller {
  static targets = ["form", "link"]

  connect() {
    debugLog("ModalButtonController: Connected");
  }

  openModal(event) {
    event.preventDefault();

    let url = null;
    if (this.hasFormTarget) {
      url = this.formTarget.action
    } else if (this.hasLinkTarget) {
      url = this.linkTarget.href;
    }

    if (!url) {
      debugLog("ModalButtonController: No form or link target found");
      return;
    }

    rrFetch(url, {
      method: "GET",
      headers: {
        headers: { Accept: "text/vnd.turbo-stream.html" }
      },
    })
    .then(response => response.text())
    .then(html => {
      Turbo.renderStreamMessage(html);
    });
  }
}
